<template lang="pug">
.item.d-flex.flex-md-column
  .left.d-flex.flex-column
    img(:src="item.area04_Content_PackageImage")
    .btns.flex-grow-1.d-flex.flex-column.align-items-center.justify-content-center.d-md-none
      router-link.contact_btn(
        v-if="false",
        tag="a",
        :to="{ name: 'CustomerServiceContactUs' }"
      ) 聯絡我們
      a.selector_round_btn(
        v-if="item.area04_Content_WebInsured == 1",
        :href="item.area04_Content_WebInsuredUrl",
        target="_blank"
      ) 網路投保
  .content.i_mt_4.i_mt_sm_0.i_ml_sm_4
    h5 {{ item.area04_Content_PackageTitle }}
    p.i_body_l.i_mt_2 {{ item.area04_Content_PackageBrief }}
    p.i_body_l.title 更多保障：
    p.i_body_l(v-html="item.area04_Content_PackageContent")
  .btns.d-none.d-md-flex.i_mt_6.justify-content-center.justify-content-md-start.align-items-center
    router-link.contact_btn(
      v-if="true",
      tag="a",
      :to="{ name: 'CustomerServiceContactUs' }"
    ) 聯絡我們
    a.selector_round_btn.i_ml_4(
      v-if="item.area04_Content_WebInsured == 1",
      :href="item.area04_Content_WebInsuredUrl",
      target="_blank"
    ) 網路投保
</template>

<script>
export default {
  props: {
    item: Object,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/product/solution/item";
</style>
